var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.668C2.96667 14.668 2.65278 14.5374 2.39167 14.2763C2.13056 14.0152 2 13.7013 2 13.3346V5.33464C2 4.96797 2.13056 4.65408 2.39167 4.39297C2.65278 4.13186 2.96667 4.0013 3.33333 4.0013H4.66667C4.66667 3.07908 4.99167 2.29297 5.64167 1.64297C6.29167 0.992969 7.07778 0.667969 8 0.667969C8.92222 0.667969 9.70833 0.992969 10.3583 1.64297C11.0083 2.29297 11.3333 3.07908 11.3333 4.0013H12.6667C13.0333 4.0013 13.3472 4.13186 13.6083 4.39297C13.8694 4.65408 14 4.96797 14 5.33464V13.3346C14 13.7013 13.8694 14.0152 13.6083 14.2763C13.3472 14.5374 13.0333 14.668 12.6667 14.668H3.33333ZM3.33333 13.3346H12.6667V5.33464H3.33333V13.3346ZM8 9.33464C8.92222 9.33464 9.70833 9.00964 10.3583 8.35964C11.0083 7.70964 11.3333 6.92352 11.3333 6.0013H10C10 6.55686 9.80556 7.02908 9.41667 7.41797C9.02778 7.80686 8.55556 8.0013 8 8.0013C7.44444 8.0013 6.97222 7.80686 6.58333 7.41797C6.19444 7.02908 6 6.55686 6 6.0013H4.66667C4.66667 6.92352 4.99167 7.70964 5.64167 8.35964C6.29167 9.00964 7.07778 9.33464 8 9.33464ZM6 4.0013H10C10 3.44575 9.80556 2.97352 9.41667 2.58464C9.02778 2.19575 8.55556 2.0013 8 2.0013C7.44444 2.0013 6.97222 2.19575 6.58333 2.58464C6.19444 2.97352 6 3.44575 6 4.0013Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.426b25f47b093348dee1e0e8e89765eb.svg";
export { ForwardRef as ReactComponent };